import { IUserSelectionStatusQuery } from '../interfaces/user-selection-status.query.interface';

export class UserSelectionStatus {
    isSelectable: boolean;
    disabledReason: string | null;

    constructor(query: IUserSelectionStatusQuery) {
        this.isSelectable = query.is_selectable;
        this.disabledReason = query.disabled_reason;
    }
}
